import request from '../request'
import qs from 'query-string'

// 文章分类
export function getAllTagListApi() {
  return request.get('/api/admin/articletags?type=kangyang')
}

// 创建文章
export function addArticeApi(params: any) {
  return request.post('/api/admin/articles', params)
}

// 文章列表
export function getArticeListApi(params: any) {
  let query = qs.stringify(params)
  return request.get(`/api/admin/articles?${query}`)
}

// 删除文章
export function deleteArticeApi(id: number) {
  return request.delete(`/api/admin/articles/${id}`)
}

// 文章详情
export function getArticeDescApi(id: number) {
  return request.get(`/api/admin/articles/${id}`)
}

// 更改详情
export function updateArticeApi(id: number, params: any) {
  return request.put(`/api/admin/articles/${id}`, params)
}